"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./EventCard.style"));

var _EventCard2 = require("./EventCard.theme");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const EventCard = ({
  size = 'small',
  title,
  subtitle,
  onClick,
  imageSrc,
  statistics
}) => {
  const cardSizeCss = _EventCard2.cardCss[size];
  const imageCss = _EventCard2.imageProps[size];
  const fontSize = size === 'small' ? 'xs' : 's';
  return (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    css: css.wrapper,
    cssProps: cardSizeCss
  }, (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    css: css.imageView,
    cssProps: {
      background: imageSrc,
      ...imageCss
    }
  }, (0, _pragma.createFelaElement)(_.View, {
    onClick: onClick,
    alignItems: "center",
    justifyContent: "center",
    css: css.imageAction
  }, size === 'small' ? (0, _pragma.createFelaElement)(_.StatementsIcon, {
    color: "icon3"
  }) : (0, _pragma.createFelaElement)(_.ImageIcon, {
    color: "icon3"
  }))), (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    flexDirection: "column",
    justifyContent: "space-between",
    padding: _EventCard2.descriptionCss[size]
  }, (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    gap: 8
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "bodyBold"
  }, title), size === 'large' && (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta"
  }, subtitle)), (0, _pragma.createFelaElement)(_.ViewsStatistics, _extends({
    isVideoIconVisible: false,
    textProps: {
      size: fontSize,
      family: 'meta',
      color: 'text.2'
    }
  }, statistics))));
};

EventCard.displayName = 'EventCard';
var _default = EventCard;
exports.default = _default;
//# sourceMappingURL=EventCard.js.map